import React from 'react';
import { Cached } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { useConfirm } from 'material-ui-confirm';
import { FormattedMessage } from 'react-intl';

import { trpc } from '../../api/trpc';
import { confirmYesNo } from '../../utils/use-confirm';

export const ReportGenerateButton = ({ month }: { month: string }) => {
  const confirm = useConfirm();

  const utils = trpc.useContext();
  const { mutate } = trpc.reports.generate.useMutation({
    onSuccess: () => {
      utils.reports.get.invalidate({ month });
    },
  });

  const generate = () => {
    confirm({
      title: (
        <FormattedMessage
          id="reports.regenerate_report_confirm_title"
          defaultMessage="Znovu vygenerovat report?"
        />
      ),
      ...confirmYesNo,
    }).then(
      () => {
        mutate({ month });
      },
      () => {
        // noop
      }
    );
  };

  return (
    <Tooltip
      title={
        <FormattedMessage
          id="reports.regenerate_report"
          defaultMessage="Znovu vygenerovat report"
        />
      }
    >
      <IconButton size="small" onClick={generate}>
        <Cached />
      </IconButton>
    </Tooltip>
  );
};
